import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from './Pages/LandingPage/index.vue';

const routes = [
    {
        path: '/',
        name: 'LandingPage',
        component: LandingPage
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return { el: to.hash, behavior: 'smooth', top: 148 };
        }
        return { top: 0 };
    }
});

export default router;
